import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarked, faSave } from '@fortawesome/free-solid-svg-icons';
//Components
import TextField from '../../../../components/TextField/TextField';
import TabelaListaGeradores from './TabelaListaGeradores';
//Api
import rotaColeta_api from '../../../../api/rotaColeta_api';
//Helpers
import { showMessage } from '../../../../helpers/message';
import { melhorarRota } from '../../../../helpers/mapas';
import { validarCampos, objCampo } from '../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../helpers/mascaras';

function initialStateGerador() {
    return {
        geradorId: "",
        fantasia: "",
        cpfcnpj: "",
        localidadeId: "",
        endereco: "",
        regional: "",
        regionalId: "",
        modalidade: "",
        modalidadeId: "",
        sequencia: "",
        latitude: "",
        longitude: "",
    }
}
export default function ListaGeradores({ permissao, rotaColeta, setRotaColeta, idRotaManutencao, openForm, setOpenForm }) {
    const [errors, setErrors] = useState({});
    //Estado que guarda as localidades que vieram da rota de get pelas modalidades e bairro
    const [localidades, setLocalidades] = useState([]);
    //Estado que guarda as opções do select de geradores
    const [optionsGeradores, setOptionsGeradores] = useState([]);
    //Estado que guarda o gerador selecionado
    const [optionGerador, setOptionGerador] = useState({});
    //Estado que guarda os dados para adicionar um gerador a lista
    const [gerador, setGerador] = useState(initialStateGerador());

    //Estado que guarda as opções do select de modalidades
    const [optionsModalidade, setOptionsModalidade] = useState([

    ]);

    const [bairro, setBairro] = useState({});
    //Estado que guarda os bairros
    const [bairros, setBairros] = useState([]);

    //Campos obrigatorios
    const campos = [
        objCampo({ name: "modalidadeId", required: true }),
    ]

    //Carrega as modalidades assim que iniciado
    useEffect(() => {
        setOptionsModalidade([]);
        rotaColeta_api.GetModalidadesContratosPorVeiculo(rotaColeta.tbVeiculos_Id).then(response => {
            response.data = response.data.map(value => {
                return { value: value.id.toString(), text: value.descricao }
            });
            setOptionsModalidade([{ text: "Selecione", value: "" }, ...response.data]);
        }).catch(e => {
            showMessage("Aviso", e.message, "error")
        })
    }, [rotaColeta.tbVeiculos_Id]);
    //Change da modalidade de coleta
    const onChangeModalidade = (e) => {
        const { name, value } = e.target;
        setBairros([]);
        setBairro([]);
        setGerador(initialStateGerador);
        setOptionsGeradores([]);
        setLocalidades([]);
        setOptionsGeradores([]);
        setOptionGerador({});
        if (value !== "") {
            rotaColeta_api.GetBairrosPorModalidade(value).then(response => {
                response.data = response.data.map(value => {
                    return { label: value.descricao, value: value.descricao }
                });
                setBairros(response.data);
            }).catch(e => showMessage("Aviso", e.message, "error", null))
        }

        const [modalidade] = optionsModalidade.filter(m => m.value === value);
        setGerador({
            ...gerador,
            modalidade: modalidade.text,
            [name]: value.toString()
        })
    }

    //Change do bairro dos geradores
    const onChangeBairro = (e, select) => {
        setOptionsGeradores([]);
        setLocalidades([]);
        setOptionsGeradores([]);
        setOptionGerador({});
        setGerador({
            ...initialStateGerador(),
            modalidade: gerador.modalidade,
            modalidadeId: gerador.modalidadeId
        })
        setBairro(e);
        rotaColeta_api.GetLocalidadesPorBairroEModalidade(gerador.modalidadeId, e.value).then(response => {
            const localidades = [];
            response.data.map(value => {
                const localidade = rotaColeta.geradores.filter(g => g.localidadeId === value.localidadeId);
                if (localidade.length === 0) {
                    value.cpfcnpj = mascaras.cpfcnpjMask(value.cpfcnpj);
                    value.enderecoLabel = value.cpfcnpj + " | " + value.fantasia + " | " + value.endereco;
                    localidades.push(value);
                }
            });

            setLocalidades(localidades);
            const options = localidades.map((value, index) => {
                return { label: value.enderecoLabel, value: value.localidadeId }
            })
            setOptionsGeradores(options);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
    }

    //Change para o campo de sequencia
    const onChangeSequencia = (index, value) => {
        const _rotaColeta = { ...rotaColeta };
        _rotaColeta.geradores[index].sequencia = value;
        setRotaColeta(_rotaColeta);
    }
    //Change para o campo de gerador localidade
    const onChangeGerador = (e, select) => {
        setOptionGerador(e);
        const [_gerador] = localidades.filter(l => l.localidadeId.toString() == e.value);

        setGerador({
            ..._gerador,
            modalidade: gerador.modalidade,
            modalidadeId: gerador.modalidadeId.toString()
        });
    }
    //Adiciona uma nova localidade a lista
    const adicionarLocalidade = () => {
        const _errors = validarCampos(gerador, campos);
        if ((_errors[1].length > 0 || Object.keys(bairro).length == 0 || gerador.geradorId == "")) {
            setErrors({ ..._errors[0], bairro: Object.keys(bairro).length == 0, gerador: gerador.geradorId == "" })
            return;
        } else {
            setErrors({});
        }
        setRotaColeta({
            ...rotaColeta,
            geradores: [...rotaColeta.geradores, {
                ...gerador, sequencia: rotaColeta.geradores.length > 0
                    ? parseInt(rotaColeta.geradores[rotaColeta.geradores.length - 1].sequencia) + 1
                    : 1
            }]
        });
        setBairro({});
        setOptionGerador({});
        setBairros([]);
        setGerador(initialStateGerador);
        setOptionsGeradores([]);
    }
    //Remove um endereço da rota
    const onClickRemover = (rowData) => {
        const _rotaColeta = { ...rotaColeta }
        _rotaColeta.geradores = _rotaColeta.geradores.filter((value, index) => {
            return rowData.localidadeId != value.localidadeId
        });
        setRotaColeta(_rotaColeta);
    }
    //Função que faz a melhora da rota dos pontos
    const melhorarRotaDePontos = () => {
        const geradoresOrganizados = melhorarRota(rotaColeta.geradores);
        if (geradoresOrganizados.length > 0) {
            setRotaColeta({
                ...rotaColeta,
                geradores: geradoresOrganizados
            })
        }
    }
    return (
        <div className='m-4 p-2 containerStep rounded-3'>
            <div className={`formContainer ${openForm ? "" : "close"}`}>
                <Row>
                    <Col md="12" lg="6">
                        <TextField label={"* Modalidade de coleta"} type={"select"} options={optionsModalidade} name={"modalidadeId"} value={gerador.modalidadeId} onChange={onChangeModalidade} invalid={errors.modalidadeId ? true : false} />
                    </Col>

                    <Col md="12" lg="6">
                        <TextField label={"* Bairro"} type={"select"} options={bairros} onChange={onChangeBairro} searchable value={bairro} invalid={errors.bairro} />
                    </Col>
                    <Col md="12" lg={"12"}>
                        <TextField label={"* Geradores"} type={"select"} options={optionsGeradores} searchable onChange={onChangeGerador} value={optionGerador} invalid={errors.gerador} />
                    </Col>
                </Row>
                <div className='d-flex align-items-center justify-content-center'>
                    <Button className='bg-gradient mb-4' color='success' onClick={adicionarLocalidade}><FontAwesomeIcon icon={faSave} /> Salvar</Button>
                    <Button className='bg-gradient mb-4 ms-3' onClick={() => {
                        setOpenForm(false)
                        setErrors({});
                    }}>Cancelar</Button>
                </div>
            </div>
            <TabelaListaGeradores
                permissao={permissao}
                items={rotaColeta.geradores}
                remover={onClickRemover}
                onChangeSequencia={onChangeSequencia} />
            <div className="d-flex align-items-center justify-content-end">
                <Button color='warning text-light' onClick={melhorarRotaDePontos}><FontAwesomeIcon icon={faMapMarked} /> Melhorar rota</Button>
            </div>
        </div>
    )
}